import * as React from 'react';
import * as COLOURS from '../../../constants/colours';
import { createTheme, ThemeProvider, useTheme } from '@mui/material/styles';

import TextField from '@mui/material/TextField';

const customTheme = (outerTheme) =>
  createTheme({
    palette: {
      mode: outerTheme.palette.mode,
    },
    components: {
      MuiTextField: {
        styleOverrides: {
          root: {
            marginBottom: 24,

            '& label': {
              color: COLOURS.white,
              opacity: 1,
              fontFamily: 'Roboto',
              fontSize: 18,
            },

            '& label.Mui-focused': {
              color: COLOURS.white,
            },
          },
        },
      },
      MuiInput: {
        styleOverrides: {
          root: {
            fontSize: 28,
            fontFamily: 'Roboto',
            fontWeight: 300,
            color: COLOURS.white,
            '&:before': {
              borderBottom: `1px solid ${COLOURS.white}`,
            },
            '&:hover:not(.Mui-disabled, .Mui-error):before': {
              borderBottom: `2px solid ${COLOURS.white}`,
            },
            '&.Mui-focused:after': {
              borderBottom: `2px solid ${COLOURS.white}`,
            },
          },
        },
      },
    },
  });

export default function SoltaLargeWhiteTextField(props) {
  const outerTheme = useTheme();
  return (
    <ThemeProvider theme={customTheme(outerTheme)}>
      <TextField {...props} fullWidth />
    </ThemeProvider>
  );
}
